import * as THREE from "three"

import backgroundVertexShader from "../../shaders/background/vertex.glsl"
import backgroundFragmentShader from "../../shaders/background/fragment.glsl"
import { backgroundFolder, debugObject, scene } from "./Experience"

export class Background {
  constructor() {
    this.setBackground()
    this.setBackground2()
    this.setTweaks()
  }

  setBackground() {
    this.background = new THREE.Mesh(
      new THREE.SphereGeometry(20, 32, 32),
      new THREE.ShaderMaterial({
        vertexShader: backgroundVertexShader,
        fragmentShader: backgroundFragmentShader,
        side: THREE.BackSide,
        // transparent: true,

        uniforms: {
          uTime: { value: 0 },
          uColor1: { value: new THREE.Color(debugObject.backgroundColor1) },
          uColor2: { value: new THREE.Color(debugObject.backgroundColor2) },

          uNoiseDetail: { value: 5 },

          uUvRotation: { value: 6 },
        },
      })
    )
    this.background.position.set(0, 0.8, 0)
    scene.add(this.background)
  }

  setBackground2() {
    this.background2 = new THREE.Mesh(
      new THREE.SphereGeometry(20, 32, 32),
      new THREE.ShaderMaterial({
        vertexShader: backgroundVertexShader,
        fragmentShader: backgroundFragmentShader,
        side: THREE.BackSide,
        // transparent: true,

        uniforms: {
          uTime: { value: 0 },
          uColor1: { value: new THREE.Color("#1a1e1f") },
          uColor2: { value: new THREE.Color(debugObject.backgroundColor2) },

          uNoiseDetail: { value: 2 },

          uUvRotation: { value: 6 },
        },
      })
    )
    this.background2.position.set(0, 0.8, 0)

    this.background2.material.stencilWrite = true
    this.background2.material.stencilRef = 1
    this.background2.material.stencilFunc = THREE.EqualStencilFunc
    this.background2.renderOrder = 4

    scene.add(this.background2)
  }

  setTweaks() {
    backgroundFolder.addInput(
      this.background.material.uniforms.uNoiseDetail,
      "value",
      {
        min: 0,
        max: 12,
        step: 1,
        label: "Noise Detail",
      }
    )

    backgroundFolder.addInput(
      this.background.material.uniforms.uUvRotation,
      "value",
      {
        min: 0,
        max: 12,
        step: 0.1,
        label: "Uv Rotation",
      }
    )

    backgroundFolder
      .addInput(debugObject, "backgroundColor1")
      .on("change", (ev) => {
        this.background.material.uniforms.uColor1.value = new THREE.Color(
          ev.value
        )
      })

    backgroundFolder
      .addInput(debugObject, "backgroundColor2")
      .on("change", (ev) => {
        this.background.material.uniforms.uColor2.value = new THREE.Color(
          ev.value
        )
      })
  }

  update(elapsedTime) {
    this.background.material.uniforms.uTime.value = elapsedTime
  }
}
